<p-dialog
  [(visible)]="displayDialog"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="false"
  [resizable]="false"
  styleClass="w-30rem"
  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }">
  <ng-template pTemplate="header">
    <app-header
      styleClass="m-0 text-xl"
      icon="fas fa-cookie-bite"
      text="Cookie- & Datenschutzeinstellungen"></app-header>
  </ng-template>

  <p class="mb-4">
    Wir verwenden Cookies und ähnliche Technologien, um das Nutzererlebnis auf
    unserer Plattform zu verbessern.
  </p>

  <div class="flex flex-column gap-3 mb-4">
    <!-- Technically necessary -->
    <div
      class="flex align-items-center justify-content-between p-3 surface-50 border-round">
      <div class="flex flex-column gap-1 pr-3">
        <span class="font-bold text-sm">Notwendige Cookies</span>
        <span class="text-xs text-color-secondary"
          >Diese Cookies sind für das fehlerfreie Funktionieren der Website
          zwingend erforderlich und können nicht deaktiviert werden.</span
        >
      </div>
      <p-button
        [disabled]="true"
        [rounded]="true"
        icon="fas fa-lock"
        severity="secondary"
        size="small"></p-button>
    </div>

    <!-- Tracking / Statistics -->
    <div
      class="flex align-items-center justify-content-between p-3 surface-50 border-round hover:surface-100 transition-colors">
      <div class="flex flex-column gap-1 pr-3">
        <span class="font-bold text-sm">Statistiken & System-Optimierung</span>
        <span class="text-xs text-color-secondary"
          >Hilft uns und den Kommunen zu verstehen, wie die Plattform genutzt
          wird, um den Kommunal-Atlas und dessen Angebot stetig zu
          verbessern.</span
        >
      </div>
      <p-inputSwitch [(ngModel)]="trackingConsent"></p-inputSwitch>
    </div>
  </div>

  <div
    class="flex flex-wrap justify-content-between gap-2 border-top-1 surface-border pt-3">
    <div class="flex gap-2 w-full">
      <p-button
        [rounded]="true"
        type="button"
        label="Nur notwendige"
        [outlined]="true"
        severity="secondary"
        (click)="acceptOnlyNecessary()"></p-button>

      <p-button
        class="ml-auto"
        [rounded]="true"
        type="button"
        label="Alle akzeptieren"
        icon="fas fa-check-circle"
        (click)="acceptAll()"></p-button>
    </div>
  </div>
</p-dialog>
